import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { Form, Field, Input } from '../../../../components/Form';
import firebase from "firebase/compat/app";
import { FirebaseAuth } from '../../../../components/FirebaseAuth/firebase';
import Alert from '../../../../components/Alert';
import UserPageLayout from '../../../../components/user/UserPageLayout';
import { log, UPDATE_EMAIL } from "../../../../libs/log";
import TotpCodeForm from '../../../../components/user/TotpCodeForm';
import { isMfaRequired } from '../../../../libs/mfa';
import { authErrorMessage } from '../../../../libs/authErrors';
var UpdateEmail = function () {
    var title = "Change Your Email";
    var _a = useState({
        hasError: false,
        error: null,
        value: ""
    }), emailAddress = _a[0], setEmailAddress = _a[1];
    var _b = useState({
        hasError: false,
        error: null,
        value: ""
    }), password = _b[0], setPassword = _b[1];
    var _c = useState({
        status: null,
        message: ''
    }), result = _c[0], setResult = _c[1];
    var _d = useState(false), inSubmit = _d[0], setInSubmit = _d[1];
    // Set when reauthentication comes back needing the account's second factor.
    var _e = useState(null), mfaResolver = _e[0], setMfaResolver = _e[1];
    /** The actual change, reused whether or not a second factor was challenged. */
    var applyNewEmail = function () {
        var user = FirebaseAuth.auth().currentUser;
        if (user === null) {
            setResult({ status: false, message: 'You are not logged in.' });
            setInSubmit(false);
            return;
        }
        // verifyBeforeUpdateEmail, not updateEmail. updateEmail is deprecated and is
        // rejected outright once email enumeration protection is on — which it is by
        // default on Identity Platform. The address does NOT change here: Firebase
        // emails a confirmation link to the NEW address and applies the change only
        // when it is clicked, which also proves the user owns that mailbox.
        user.verifyBeforeUpdateEmail(emailAddress.value).then(function () {
            log(UPDATE_EMAIL);
            setResult({
                status: true,
                message: 'Almost done. We\'ve sent a confirmation link to ' + emailAddress.value +
                    '. Open it to finish changing your email address — until you do, keep signing in with your current one.'
            });
            setInSubmit(false);
        }).catch(function (err) {
            setResult({ status: false, message: authErrorMessage(err === null || err === void 0 ? void 0 : err.code) || 'We could not change your email address.' });
            setInSubmit(false);
        });
    };
    return (_jsxs(UserPageLayout, { title: title, children: [result.status === null && mfaResolver !== null &&
                _jsx(TotpCodeForm, { resolver: mfaResolver, onSuccess: function () { setMfaResolver(null); setInSubmit(true); applyNewEmail(); }, onFailure: function (msg) { setMfaResolver(null); setResult({ status: false, message: msg }); } }), result.status === null && mfaResolver === null &&
                _jsxs(Form, { handleSubmit: function (e) {
                        e.preventDefault();
                        setInSubmit(true);
                        var user = FirebaseAuth.auth().currentUser;
                        if (user === null) {
                            setResult({
                                status: false,
                                message: 'You are not logged in.'
                            });
                            setInSubmit(false);
                            return;
                        }
                        // check password
                        var credential = firebase.auth.EmailAuthProvider.credential(user.email || "", // login will fail if no email address
                        password.value);
                        user.reauthenticateWithCredential(credential)
                            .then(function () {
                            applyNewEmail();
                        }).catch(function (err) {
                            // Previously a blind catch that always blamed the password.
                            // With a second factor enrolled, reauthentication throws
                            // auth/multi-factor-auth-required, so the correct password
                            // was being reported as wrong.
                            if (isMfaRequired(err)) {
                                setMfaResolver(err.resolver);
                                setInSubmit(false);
                                return;
                            }
                            if ((err === null || err === void 0 ? void 0 : err.code) === 'auth/wrong-password' || (err === null || err === void 0 ? void 0 : err.code) === 'auth/invalid-credential') {
                                setPassword({
                                    hasError: true,
                                    error: 'Incorrect password, authentication failed.',
                                    value: password.value
                                });
                                setInSubmit(false);
                                return;
                            }
                            setResult({ status: false, message: authErrorMessage(err === null || err === void 0 ? void 0 : err.code) || 'We could not verify your password.' });
                            setInSubmit(false);
                        });
                    }, disabled: emailAddress.hasError || password.hasError || emailAddress.value === "" || password.value === "" || inSubmit, inSubmit: inSubmit, enableDefaultButtons: true, backToUrl: "/user/profile", children: [_jsx(Field, { label: "Email Address", children: _jsx(Input, { type: "email", name: "email-address", hasError: emailAddress.hasError, error: emailAddress.error, minLen: 5, maxLen: 50, required: true, validRegex: "^[a-zA-Z0-9-_+\\.]*@[a-zA-Z0-9-_\\.]*\\.[a-zA-Z0-9-_\\.]*$", changeHandler: setEmailAddress }) }), _jsx(Field, { label: "Current Password", children: _jsx(Input, { type: "password", name: "password", hasError: password.hasError, error: password.error, required: true, changeHandler: setPassword }) })] }), result.status === false &&
                _jsxs(_Fragment, { children: [_jsx(Alert, { type: "danger", dismissible: false, message: result.message, onDismiss: function () { } }), _jsx("button", { className: "btn btn-primary mr-2", onClick: function () {
                                setResult({
                                    status: null,
                                    message: ''
                                });
                            }, children: "Try Again" }), _jsx(Link, { className: "btn btn-secondary", to: "/user/profile", children: "View Profile" })] }), result.status === true &&
                _jsxs(_Fragment, { children: [_jsx(Alert, { type: "success", dismissible: false, message: result.message, onDismiss: function () { } }), _jsx(Link, { className: "btn btn-primary", to: "/user/profile", children: "View Profile" })] })] }));
};
export default UpdateEmail;
